import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {AppService} from "../../app.service";
import {ApiRequestService} from "../../shared/api-request.service";
import {UtilsService} from "../../shared/utils.service";
import {tap} from "rxjs/operators";
import {ApiDataSource} from "../../utils/api-data-source";
import {AssetModel} from "../../models/asset.model";

@Component({
  selector: 'app-assets-view-files',
  templateUrl: './assets-view-files.component.html',
  styleUrls: ['./assets-view-files.component.scss']
})
export class AssetsViewFilesComponent implements OnInit, AfterViewInit {

  @Input('asset_id') asset_id: number;
  @Input('asset') asset: AssetModel;

  dataSource: AssetsViewFilesDataSource = new AssetsViewFilesDataSource(this.app, this.api);

  listColumns: string[] = [
    'id',
    'thumbnail',
    'name',
    'date_created',
    // 'date_created_UTC',
    'actions'
  ];

  // the paginator and sorter
  @ViewChild('paginator1') paginator1: MatPaginator;
  @ViewChild('paginator2') paginator2: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private app: AppService,
    private api: ApiRequestService,
    public utils: UtilsService
  ) { }

  ngOnInit() {
    this.dataSource.asset_id = this.asset_id;
    this.dataSource.getData();
  }

  ngAfterViewInit() {
    // Reset the paginator when sorting takes place
    this.sort.sortChange.subscribe(() => {
      this.paginator1.pageIndex = 0;
      this.paginator2.pageIndex = 0;
    });

    const paginatorTap = tap((paginator) => {
      this.paginator1.pageIndex = paginator['pageIndex'];
      this.paginator1.pageSize = paginator['pageSize'];
      this.paginator2.pageIndex = paginator['pageIndex'];
      this.paginator2.pageSize = paginator['pageSize'];

      this.dataSource.limit = paginator['pageSize'];
      this.dataSource.offset = paginator['pageIndex'];
      this.dataSource.getData();
    });

    // Subscribe to the paginator tap events.
    this.paginator1.page.pipe(paginatorTap).subscribe();
    this.paginator2.page.pipe(paginatorTap).subscribe();

    // Subscribe to the sorter tap events.
    this.sort.sortChange.pipe(tap((sorter) => {
      this.dataSource.order_by = sorter['active'];
      this.dataSource.order = sorter['direction'];

      // Sort UTC dates based on their corresponding date column.
      if ( sorter['active'] == 'date_created_UTC' ) {
        this.dataSource.order_by = 'date_created';
      }

      this.dataSource.getData();
    })).subscribe();
  }

  /**
   * Notifies the user that the URL has been copied to their clipboard via a toast message.
   *
   * @return {void} Does not return any value.
   */
  onCopiedURL(): void {
    this.utils.showToast('The URL is copied to your clipboard.');
  }

  /**
   * View the uploaded files.
   *
   * @param url The URL to view.
   */
  onViewFile(url: string): void {
    this.utils.openUrl(url);
  }
}

export class AssetsViewFilesDataSource extends ApiDataSource {
  order_by = 'date_created';
  order = 'desc';
  asset_id: number;

  getData(resetOffset: boolean = false) {
    this.makeRequest(`v2/assets/${this.asset_id}/files`, resetOffset);
  }
}
